import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import { openErrorDialog, openSuccessDialog } from '../dialog/dialogActions';
import HealthApi from '../../apis/health';


export const getLatestRecordRequest = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.GET_LATEST_RECORD,
        api: HealthApi.getLatestRecord,
        successCallback: response => {
          dispatch({
            type: types.GET_LATEST_RECORD,
          });

          // getLastFiveRecords after getLatestRecordRequest is successful
          dispatch(getLastFiveRecords());
        },
        useErrorDialog: true,
      })
    );
  };
};

export const saveUserPreferences = sectionPreferences => {
  return dispatch => {
    dispatch(execApiWithParam({
        type: types.SAVE_USER_PREFERENCES,
        api: HealthApi.saveUserPreferences,
        param: sectionPreferences,
        successCallback: response => {
          dispatch(openSuccessDialog({
            title: 'Preferences saved',
          }));
        },
        // Our 'success: false' response object. Also called on catch of an exception.
        errorCallback: response => {
          dispatch(openErrorDialog({
            title: 'Failed to save your preferences.',
            content: response.message.body,
          }));
        },
      })
    );
  };
};

export const recordSearch = data => {
  return dispatch => {
    dispatch(execApiWithParam({
        type: types.RECORD_SEARCH,
        api: HealthApi.recordSearch,
        param: data,
        successCallback: response => {
          dispatch({
            type: types.RECORD_HEADERS,
            payload: response.headers,
          });
        },
        // Our 'success: false' response object. Also called on catch of an exception.
        errorCallback: response => {
          dispatch(openErrorDialog({
            content: response.message.body,
          }));
        },
      })
    );
  };
};

// Invoke RECORD_SEARCH with this API and on success dispatch RECORD_HEADERS
export const getLastFiveRecords = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.RECORD_SEARCH,
        api: HealthApi.getLastFiveRecords,
        successCallback: response => {
          dispatch({
            type: types.RECORD_HEADERS,
            payload: response.headers,
          });
        },
        useErrorDialog: true,
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/health/healthActions.js